import { createPluginOptions } from "../create-plugin-options";

export const defaultDynamicImageDataOptions = createPluginOptions()({
	dynamicImage: "",
	period: null as number | null,
});

export type DynamicImageDataOptions = typeof defaultDynamicImageDataOptions;
